import { render } from "./SolicitudesRechazadas.vue?vue&type=template&id=2ee61e12&scoped=true"
import script from "./SolicitudesRechazadas.vue?vue&type=script&lang=js"
export * from "./SolicitudesRechazadas.vue?vue&type=script&lang=js"

import "./SolicitudesRechazadas.vue?vue&type=style&index=0&id=2ee61e12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee61e12"]])

export default __exports__